import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { quotePropertyName } from '@cli-utils/text.js'
import { selectDefaultValues } from './select-default-values.js'

export function defaultFallbackValue(f: SchemaField): string {
  if (f.type === 'list' || f.type === 'gallery') return '[]'
  if ((f.type === 'group' || f.type === 'section') && f.fields?.length) {
    const values = f.fields.flatMap((nestedField) => {
      const entries = [
        `${quotePropertyName(nestedField.name)}: ${defaultFallbackValue(nestedField)}`
      ]
      if (nestedField.hasIcon) {
        entries.push(`${quotePropertyName(`${nestedField.name}Icon`)}: ''`)
      }
      return entries
    })
    return `{ ${values.join(', ')} }`
  }
  if (f.type === 'boolean') return f.default === true ? 'true' : 'false'
  if (f.type === 'number' || f.type === 'decimal') return f.required ? '0' : 'undefined'
  if (f.type === 'uuid' || f.type === 'serial' || f.type === 'relationship') {
    return f.multiple ? '[]' : "''"
  }
  if (f.type === 'date' || f.type === 'timestamp') return 'undefined'
  if (f.type === 'select') {
    if (f.multiple) return JSON.stringify(selectDefaultValues(f))
    return f.default !== undefined && f.default !== null ? JSON.stringify(f.default) : "''"
  }
  if (f.default !== undefined && f.default !== null) {
    return typeof f.default === 'string' ? JSON.stringify(f.default) : String(f.default)
  }
  return "''"
}
